import { IdEntityType } from './types';

// Visual constants for command palette
export const PALETTE_COLORS = {
  selected: 'brand.purple',
  selectedBg: 'brand.lightGray1',
  text: 'brand.black',
  textSecondary: 'brand.darkGray',
  textMuted: 'brand.mediumGray',
  border: 'brand.lightGray1',
  transparent: 'transparent',
} as const;

export const PALETTE_SPACING = {
  itemPadding: '12px 16px',
  itemSpacing: '12px',
  sectionPadding: '16px',
  sectionHeader: '8px',
} as const;

export const PALETTE_SIZES = {
  iconSize: '20px',
  fontSize: '14px',
  fontSizeSmall: '12px',
  borderWidth: '3px',
  kbdPadding: '6px',
  modalMaxHeight: '60vh',
  modalTop: '20vh',
} as const;

export const PALETTE_TRANSITIONS = {
  default: 'all 0.1s',
} as const;

export const SEARCH_CONFIG = {
  debounceMs: 300,
  minCharsForSearch: 3,
  focusDelayMs: 100,
} as const;

export const ID_SELECT_ITEMS: { type: IdEntityType; label: string; description: string }[] = [
  {
    type: 'company',
    label: 'Company by ID',
    description: 'Navigate to a company profile by its ID',
  },
  {
    type: 'individual',
    label: 'Individual by ID',
    description: 'Navigate to an individual profile by their ID',
  },
];
